import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { UserModel } from "../../../features/user/userTypes";
import Image from "react-bootstrap/Image";

type Props = {
    user: UserModel;
};

const TeamPlayers = ({ user }: Props) => {
    return (
        <Card className={"mt-4"}>
            <Card.Body>
                <Row className="align-items-center">
                    <Col xs={12} md={12} className="text-center mb-3 mb-md-0">
                        <Image
                            src={user.avatar}
                            alt={user.name}
                            style={{ width: "120px" }}
                            roundedCircle
                        />
                    </Col>
                    <Col xs={12} md={12} className={'align-items-center text-center justify-content-center m-2'}>
                        <h2 style={{ margin: "0" }}>
                            {user.name}{" "}
                            <Image
                                className={'ms-2 rounded'}
                                src={user.country_image}
                                alt="flag"
                                style={{ width: "35px" }}
                            />
                        </h2>
                    </Col>
                    <Col xs={12} md={12}>
                        <div className="d-flex align-items-center justify-content-center mt-3">
                            <Image src={user.car_image} alt="car" className={'w-75'} />
                        </div>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};

export default TeamPlayers;
